// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import VueI18n from 'vue-i18n'
import axios from 'axios'

Vue.prototype.$axios = axios
Vue.use(VueResource)
Vue.config.productionTip = false

const buildConfig = require('../config/' + process.env.BUILD_ENV + '.config')
Vue.prototype.$buildConfig = buildConfig
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: buildConfig.LANG,
  messages: {
    'ko': require('@/assets/lang/ko.js'),
    'zh': require('@/assets/lang/zh.js'),
    'en': require('@/assets/lang/en.js')
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js